import React, { useEffect, useState } from "react";
import {
  Card,
  Descriptions,
  Tag,
  Avatar,
  Divider,
  Badge,
  Spin,
  Empty,
} from "antd";
import {
  UserOutlined,
  PhoneOutlined,
  MailOutlined,
  IdcardOutlined,
  BookOutlined,
} from "@ant-design/icons";
import { gatewayCRUD } from "../../../../actions/gateway";
import { set } from "lodash";
import { log } from "mathjs";
import { Loader } from "rsuite";

export const CustomerProfile = (props) => {
  const { dataId } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  // useEffect(() => {
  //   if (dataId) {
  //     setLoading(true);
  //     setTimeout(() => {
  //       gatewayCRUD
  //         .addStudentProfile({ registration_number: dataId })
  //         .then((resp) => {
  //           setData(resp.data);
  //         })
  //         .catch(() => {
  //           setData(null);
  //         })
  //         .finally(() => {
  //           setLoading(false);
  //         });
  //     }, 500);
  //   }
  // }, [dataId]);

  const fullName = `${data?.firstName} ${data?.middleName} ${data?.lastName}`;

  return (
    <div className="container-fluid ">
      <div className="container py-5">
        {loading ? (
          <div className="text-center py-5">
            <Loader size="md" />
          </div>
        ) : !data ? (
          <div className="text-center py-5">
            <Empty description="No Student Profile Found" />
          </div>
        ) : (
          <Card className="student-card shadow-lg">
            <div className="row">
              {/* LEFT PROFILE SECTION */}
              <div className="col-md-4 text-center profile-section">
                <Avatar
                  size={160}
                  src={
                    data?.profile
                      ? `data:image/jpeg;base64,${data.profile}`
                      : null
                  }
                  icon={<UserOutlined />}
                  className="profile-avatar"
                />

                <p className="mt-3 h4 student-name">{fullName}</p>

                <Tag color="blue" className="mb-2">
                  {data?.program?.programCode}
                </Tag>

                <div>
                  <Badge
                    status="processing"
                    text={data?.status?.statusValue}
                    className="status-badge"
                  />
                </div>

                <Divider />

                <div className="contact-info">
                  <p>
                    <PhoneOutlined /> +{data?.phoneNumber}
                  </p>
                  <p>
                    <MailOutlined /> {data?.email}
                  </p>
                </div>
              </div>

              {/* RIGHT DETAILS SECTION */}
              <div className="col-md-8">
                <Descriptions
                  title="Academic Information"
                  bordered
                  column={1}
                  size="middle"
                >
                  <Descriptions.Item label="Admission Year">
                    {data?.admissionYear?.academicYearName}
                  </Descriptions.Item>
                  <Descriptions.Item label="Admission Number">
                    {data?.admissionNumber}
                  </Descriptions.Item>

                  <Descriptions.Item label="Registration Number">
                    {data?.registrationNumber}
                  </Descriptions.Item>

                  <Descriptions.Item label="Program Level">
                    {data?.program?.programLevel?.levelCode}
                  </Descriptions.Item>

                  <Descriptions.Item label="Program Name">
                    {data?.program?.programAdmissionName}
                  </Descriptions.Item>

                  <Descriptions.Item label="Program Duration">
                    {data?.program?.programYears} Years
                  </Descriptions.Item>

                  <Descriptions.Item label="Study Year">
                    {data?.studyYear}
                  </Descriptions.Item>
                </Descriptions>

                <Divider />

                <Descriptions
                  title="Personal Information"
                  bordered
                  column={1}
                  size="middle"
                >
                  <Descriptions.Item label="Gender">
                    {data?.gender === "M" ? "Male" : "Female"}
                  </Descriptions.Item>

                  <Descriptions.Item label="Date of Birth">
                    {data?.dateOfBirth}
                  </Descriptions.Item>

                  <Descriptions.Item label="Citizenship">
                    {data?.citizenship}
                  </Descriptions.Item>

                  <Descriptions.Item label="Sponsor">
                    {data?.sponsor}
                  </Descriptions.Item>

                  <Descriptions.Item label="Region">
                    {data?.region}
                  </Descriptions.Item>

                  <Descriptions.Item label="District">
                    {data?.district}
                  </Descriptions.Item>
                </Descriptions>
              </div>
            </div>
          </Card>
        )}
      </div>
    </div>
  );
};
